import React, { useState } from 'react';
import './TimeLimitPage.css';
import YuGiOhTimer from '../components/YuGiOhTimer';
import ChessTimer from '../components/ChessTimer';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { playSound } from '../utils/soundPlayer';
import MasterDuelTimer from '../components/MasterDuelTimer';

const TimeLimitPage = () => {
  const [mode, setMode] = useState(null);
  const [paused, setPaused] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const [clockRunning, setClockRunning] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showBackButton, setShowBackButton] = useState(true);
  const [backButtonDisabled, setBackButtonDisabled] = useState(false);



  return (
    <div className="time-limit-container">
      {!mode ? (
        <>

          <button
            className="back-button"
            onClick={() => {
              playSound('return');
              navigate('/tool');
            }}
          >
            {t('common.back')}
          </button>

          <h2>{t('timeLimit.chooseMode')}</h2>
          <div className="timer-mode-buttons">
            <button onClick={() => setMode('yugioh')}>
              {t('timeLimit.yugioh')}
            </button>
            <button onClick={() => setMode('chess')}>
              {t('timeLimit.chess')}
            </button>
            <button onClick={() => setMode('masterduel')}>
              Master Duel
            </button>
          </div>

        </>
      ) : mode === 'yugioh' ? (
        <>
          <button className="back-button" onClick={() => setMode(null)}>
            {t('common.back')}
          </button>
          <YuGiOhTimer />
        </>
      ) : mode === 'masterduel' ? (
        <>
          <button
            className="back-button"
            onClick={() => setMode(null)}
            disabled={backButtonDisabled}
          >
            {t('common.back')}
          </button>
          <MasterDuelTimer
            setShowBackButton={setShowBackButton}
            setBackButtonDisabled={setBackButtonDisabled}
          />
        </>
      ) : (

        <>
          <button
            className="back-button"
            onClick={() => {
              playSound('return');
              setMode(null);
            }}
            disabled={(clockRunning && !paused) || backButtonDisabled}

          >
            {t('common.back')}
          </button>
          <ChessTimer
            setPaused={setPaused}
            paused={paused}
            setHasStarted={setHasStarted}
            setClockRunning={setClockRunning}
            clockRunning={clockRunning}
          />
        </>
      )}
    </div>
  );
};

export default TimeLimitPage;
